


import {
  defineComponent,
  PropType,
  reactive,
} from '@vue/composition-api';
import useSettouPatrolContext from '@/components/Sp/Johaisetsu/SettouPatrol/composables/useSettouPatrolContext';
import { JohaisetsuCarExt } from '@/models/johaisetsu/settouSagyouReport/spJohaisetsuReport';

interface State {
  showConfirmTemporarilyStopWorkingModal: boolean;
  showConfirmStopWorkingModal: boolean;
}

export default defineComponent({
  props: {
    selectedJohaisetsuType: {
      type: String,
      required: true,
    },
    isRequesting: {
      type: Boolean,
      required: true,
    },
    johaisetsuCar: {
      type: Object as PropType<JohaisetsuCarExt>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const state = reactive<State>({
      showConfirmTemporarilyStopWorkingModal: false,
      showConfirmStopWorkingModal: false,
    });
    const {
      sagyouActionLabel,
      johaisetsuTypeNameDisp,
      isShowJohaisetsuTypeSelect,
      pauseWorkingLabel,
      stopWorkingLabel,
    } = useSettouPatrolContext({ selectedJohaisetsuType: props.selectedJohaisetsuType });
    const editWorkSituation = () => {
      emit('editWorkSituationOnCommon');
    };
    const createReport = () => {
      emit('createReportOnCommon');
    };
    const showConfirmTemporarilyStopWorkingModal = () => {
      state.showConfirmTemporarilyStopWorkingModal = true;
    };
    const showConfirmStopWorkingModal = () => {
      state.showConfirmStopWorkingModal = true;
    };
    const temporarilyStopWorking = () => {
      state.showConfirmTemporarilyStopWorkingModal = false;
      emit('temporarilyStopWorkingOnCommon');
    };
    const stopWorking = async() => {
      state.showConfirmStopWorkingModal = false;
      emit('stopWorkingOnCommon');
    };
    return {
      state,
      sagyouActionLabel,
      johaisetsuTypeNameDisp,
      isShowJohaisetsuTypeSelect,
      pauseWorkingLabel,
      stopWorkingLabel,
      editWorkSituation,
      createReport,
      showConfirmTemporarilyStopWorkingModal,
      temporarilyStopWorking,
      showConfirmStopWorkingModal,
      stopWorking,
    };
  },
});
